import React from 'react';
import LocationTemplate from './LocationTemplate';

const TrentonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Trenton"
      stateName="North Carolina"
      countyName="Jones"
      zipCodes={["28585"]}
      latitude={35.0563}
      longitude={-77.3353}
      population={287}
      historicalFact="County seat of Jones County, established in 1779 and named after Trenton, New Jersey."
      nearbyTowns={[
        "Kinston, NC",
        "New Bern, NC",
        "Pollocksville, NC",
        "Maysville, NC",
        "Pink Hill, NC",
        "Deep Run, NC",
        "Richlands, NC",
        "Jacksonville, NC"
      ]}
    />
  );
};

export default TrentonPage;